import { useState, useEffect } from "react";
import { PRODUCTOS_DEFAULT } from "../data/productos";

export default function useProductos() {
  const [productos, setProductos] = useState(PRODUCTOS_DEFAULT);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    try {
      const stored = localStorage.getItem("productos-catalogo");
      if (stored) {
        const parsed = JSON.parse(stored);
        if (Array.isArray(parsed) && parsed.length > 0) {
          setProductos(parsed);
        }
      }
    } catch {
      // Key doesn't exist yet, use defaults
    }
    setLoaded(true);
  }, []);

  const saveProductos = (newProds) => {
    setProductos(newProds);
    try {
      localStorage.setItem("productos-catalogo", JSON.stringify(newProds));
    } catch (e) {
      console.error("Error guardando productos:", e);
    }
  };

  return { productos, saveProductos, loaded };
}
